import { render, staticRenderFns } from "./InitioHeader.vue?vue&type=template&id=3f119805&scoped=true&"
import script from "./InitioHeader.vue?vue&type=script&lang=js&"
export * from "./InitioHeader.vue?vue&type=script&lang=js&"
import style0 from "./InitioHeader.vue?vue&type=style&index=0&id=3f119805&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f119805",
  null
  
)

export default component.exports